.inputRoot {
  flex: 1;
}
